import { render, staticRenderFns } from "./ManageSession.vue?vue&type=template&id=aaae1aa4"
import script from "./ManageSession.vue?vue&type=script&lang=js"
export * from "./ManageSession.vue?vue&type=script&lang=js"
import style0 from "./ManageSession.vue?vue&type=style&index=0&id=aaae1aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports